export default "__VITE_ASSET__f8bca213__"